import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-sop-cls',
  templateUrl: './sop-cls.component.html',
  styleUrls: ['./sop-cls.component.css']
})
export class SopClsComponent implements OnInit {
    sopKeyno;

    public setting?: Setting;

    public itemsListChoices: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.sopKeyno = this.stateService.getStateParams()['sop_keyno'];
    }

    private async loadSetting() {
        if (!!this.sopKeyno) {
            this.setting = (await this.datatask.Post(1848, { sop_keyno: this.sopKeyno }))[0];
        }
    }

    private async loadChoices() {
        if (!this.setting) return;

        return this.itemsListChoices = await this.datatask.Post(1851, { sop_keyno: this.setting.sop_keyno });
    }

    private async init() {
        await this.loadSetting();
        this.loadChoices();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    sop_keyno: string;
    sop_name: string;
}
